var searchForm = {
    bindings : {
        activate : '<'
    },
    controller : function SearchFormCtrl ($element, $timeout) {
        
        var searchField;

        function link () {
            searchField = $element[0].querySelector('input');
        }

        function onChanges (changes) {
            if (ctrl.activate) {
                
                $timeout(function(){
                    searchField.focus();
                }, 0);
            }
        }

        var ctrl = this;

        this.searchAction = baseUrl;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl : themeUrl + '/assets/static/html/search-form.component.html',
};